
import { LineSegments, BufferGeometry, Float32BufferAttribute, LineBasicMaterial, Color } from 'three';

class GridHelper extends LineSegments {

    constructor(sizeX = 10, sizeY = 10, color1 = 0x000000, color2 = 0xaaaaaa) {
        const divisionsX = sizeX * 10;
        const divisionsY = sizeY * 10;
        color1 = new Color(color1);
        color2 = new Color(color2);

        const stepX = sizeX / divisionsX;
        const stepY = sizeY / divisionsY;
        const halfSizeX = sizeX / 2;
        const halfSizeY = sizeY / 2;

        const vertices = [], colors = [];

        for (let i = 0, j = 0, k = - halfSizeX, p = - halfSizeY;
             i <= Math.max(divisionsX, divisionsY);
             i ++, k += stepX,  p += stepY) {
            // for (let p = - halfSizeY; p <= divisionsY; p += stepY) {
            //     vertices.push(- halfSizeX, 0, p, halfSizeX, 0, p);

            // color = !(Math.round(k/stepX)%10) ? color1 : color2;
                if (i <= divisionsX){
                    // color = !(i % 10) ? color1 : color2;
                    // color = !(Math.round(k/stepX)%10) ? color1 : color2;
                    vertices.push(k, 0, - halfSizeY, k, 0, halfSizeY);
                } else {
                    vertices.push(0, 0, 0, 0, 0, 0);
                }
                if (i <= divisionsY) {
                    // color = !(Math.round(p/stepY)%10) ? color1 : color2;
                    vertices.push(-halfSizeX, 0, p, halfSizeX, 0, p);
                } else {
                    vertices.push(0, 0, 0, 0, 0, 0);
                }
                const color = !(i % 10) ? color1 : color2;

                // const color = color1;

                color.toArray(colors, j); j += 3;
                color.toArray(colors, j); j += 3;
                color.toArray(colors, j); j += 3;
                color.toArray(colors, j); j += 3;
            // }
        }

        // for (let i = 0, j = 0, p = - halfSizeY; i <= divisionsY; i ++, p += stepY) {
        //     vertices.push(- halfSizeX, 0, p, halfSizeX, 0, p);
        //
        //     // const color = !(i % 2) ? color1 : color2;
        //     const color = color2;
        //     color.toArray(colors, j); j += 3;
        //     color.toArray(colors, j); j += 3;
        //     color.toArray(colors, j); j += 3;
        //     color.toArray(colors, j); j += 3;
        // }

        const geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));

        const material = new LineBasicMaterial({ vertexColors: true, toneMapped: false });

        super(geometry, material);

        this.type = 'GridHelper';

    }

    dispose() {
        this.geometry.dispose();
        this.material.dispose();

    }

}


export { GridHelper };
